<template>
    <ErrorLayout title="errors.connectionTimeout" subtitle="errors.connectionTimeoutSubtitle">
        <template #buttons>
            <b-button variant="primary" @click="refreshPage">{{ t('retry') }}</b-button>
        </template>
    </ErrorLayout>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

function refreshPage() {
    window.location.reload();
}
</script>
